// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeContactModel {
    static getAttributeTypeMap() {
        return SimpleIntakeContactModel.attributeTypeMap;
    }
}
SimpleIntakeContactModel.discriminator = undefined;
SimpleIntakeContactModel.additionalProperties = false;
SimpleIntakeContactModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "job",
        "baseName": "job",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "note",
        "baseName": "note",
        "type": "string"
    },
    {
        "name": "phones",
        "baseName": "phones",
        "type": "SimpleIntakeContactPhonesModel"
    },
    {
        "name": "preferred",
        "baseName": "preferred",
        "type": "ContactInfoType"
    },
];
//# sourceMappingURL=simpleIntakeContactModel.js.map